import React from 'react';
import ClipboardJS from 'clipboard';
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';

import ResultSet from '../../../../libs/ResultSet';

import './Button.scss';

const Button = props => {
    let retThis = '';
    
    new ClipboardJS('.btn--1');
    const demoHanldr = () => {
        props.onToggleDemo();
    }

    if(props.type===1){
        retThis = (
            <button className="Button Button--2" onClick={demoHanldr}>
                <div className="Button__img"></div>
                <div className="Button__txt">{ResultSet.btn1[props.currentLang]}</div>
            </button>
        )
    }else if(props.type===2){
        const roleSend = props.currentRole.replace(/\b( )\b/g, match => "_");

        retThis = (
            <React.Fragment>
                <a href={`http://${window.location.host}${window.location.pathname}?report=true&score=${props.specificScore.join('_')}&role=${roleSend}`} className="Button Button--1 btn--1" target='_blank' rel='noreferrer'>
                    <div className="Button__img" ></div>
                    <div className="Button__txt">{ResultSet.btn2[props.currentLang]}</div>
                </a>
                <div className="Button__copied">{ResultSet.copied[props.currentLang]}</div>            
            </React.Fragment>
        )    
    }
    return retThis;    
}

const mapStateToProps = state => { 
    return {
        currentRole: state.roleReducer.currentRole,
        specificScore: state.scoreReducer.specificScore,
        currentLang: state.langReducer.currentLang,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleDemo: () => dispatch(actionCreators.toggle_demo()),
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(Button);